/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import getWindow from './getWindow';

export class UrlParser {
    constructor({ windowInterface }) {
        this.window = windowInterface;
    }

   mapIteratorToPlainObj = (iterator) => {
       const output = {};
       if (!(Symbol.iterator in Object(iterator))) {
           return {};
       }

       if (typeof iterator === 'string' && iterator.length) {
           const tuples = iterator.slice(1, iterator.length).split('&');
           tuples.forEach((tuple) => {
               const [key, val] = tuple.split('=');
               output[key.trim()] = val.trim();
           });

           return output;
       }

       // eslint-disable-next-line no-restricted-syntax
       for (const [key, value] of iterator) {
           output[key] = value;
       }

       return output;
   }

   isValid = (url) => {
       if (typeof url !== 'string') {
           return false;
       }

       const lowercase = url.toLowerCase();

       if (lowercase === 'undefined' || lowercase === 'null') {
           return false;
       }

       return true;
   }


   /**
    *
    * @param {string} url
    * @returns { object }
    * @example {
    *    error: boolean,
    *    url: string,
    *    host?: string,
    *    path?: string,
    *    queryString?: string,
    * }
    */
   parse = (url) => {
       const isSSR = this.window === null;

       let reconciledUrl;
       if (isSSR && url) {
           reconciledUrl = url;
       } else if (!isSSR) {
           reconciledUrl = this.window.location.href;
       }

       if (!this.isValid(reconciledUrl)) {
           return {
               error: true,
               url: String(reconciledUrl),
           };
       }


       let parser;
       try {
           parser = new URL(reconciledUrl);
       } catch (err) {
           return {
               error: true,
               url: reconciledUrl,
           };
       }

       const queryString = this.mapIteratorToPlainObj(parser.searchParams || parser.search);

       return {
           error: false,
           url: reconciledUrl,
           host: parser.host,
           path: parser.pathname,
           queryString,
       };
   }
}

const window = getWindow();

const urlParser = new UrlParser({
    windowInterface: window,
});

export default urlParser;
